<script>
    import Header from './Header.svelte';
    import Router from './Router.svelte';
    import { currentPage } from './store';

    function navigateTo(page) {
        currentPage.set(page);
    }

    function handleHeaderClick(event) {
        const page = event.detail.detail;
        navigateTo(page);
    }
</script>

<svelte:head>
    <meta charset="utf-8" />
    <title>DeclanM - Website Developer</title>
    <link rel="preconnect" href="https://fonts.gstatic.com">
    <link href="https://fonts.googleapis.com/css2?family=Libre+Baskerville:ital,wght@0,400;0,700;1,400&display=swap" rel="stylesheet">
</svelte:head>

<main>
    <Header on:click={handleHeaderClick} />
    <Router />
    <div id="grad-ball-1"></div>
</main>

<style>
    main {
        text-align: center;
        padding: 1em;
        height:100%;
    }
</style>